import React from "react";
import styled, { keyframes } from "styled-components";

// Icon-only nav entry that opens the NewsletterModal via window event.
// Mounted in Header next to ProfileAvatar; the modal lives at root via
// gatsby-browser.wrapRootElement so the icon doesn't need local state.

const pulse = keyframes`
  0%, 100% { opacity: 0.25; transform: scale(1); }
  50%      { opacity: 0.9;  transform: scale(1.4); }
`;

const Wrap = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 4px;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: var(--nd-text-secondary);
  line-height: 0;

  &:hover,
  &:focus {
    color: var(--nd-text-display);
    outline: none;
  }

  &:hover svg path,
  &:focus svg path {
    stroke: var(--nd-text-display);
  }
`;

const PulseDot = styled.span`
  position: absolute;
  top: 2px;
  right: 2px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--nd-text-display);
  animation: ${pulse} 3.2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  pointer-events: none;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.6;
  }
`;

const EnvelopeSvg = () => (
  <svg width="18" height="14" viewBox="0 0 18 14" aria-hidden="true">
    <path
      d="M1 2 L9 8 L17 2 M1 2 L1 12 L17 12 L17 2 L1 2 Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinejoin="miter"
    />
  </svg>
);

const NewsletterButton = () => {
  const onClick = () => {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("nl:open-signup"));
    }
  };
  return (
    <Wrap
      type="button"
      title="Subscribe to the Dioscuro newsletter"
      aria-label="Subscribe to the newsletter"
      onClick={onClick}
    >
      <EnvelopeSvg />
      <PulseDot aria-hidden="true" />
    </Wrap>
  );
};

export default NewsletterButton;
